<script setup lang="ts">
const { t } = useI18n();

const emit = defineEmits<{
  (e: 'sign-in'): void;
  (e: 'sign-up'): void;
}>();
</script>

<template>
  <div
    class="mb-[18px] flex flex-col items-stretch gap-3 rounded-[14px] border border-gold-primary-100/40 bg-gradient-to-r from-gold-primary-10 to-[#FAF6EC] px-[22px] py-4 tablet:flex-row tablet:items-center tablet:justify-between tablet:gap-4"
  >
    <div class="min-w-0 tablet:flex-1">
      <div class="mb-1 font-mono text-[10px] font-bold uppercase tracking-[0.1em] text-[#8B6000]">
        {{ t('property.access.guestSignupBanner.badge') }}
      </div>
      <i18n-t
        keypath="property.access.guestSignupBanner.description"
        tag="div"
        class="max-w-[720px] text-[14px] leading-[1.45] text-black-80"
      >
        <template #bold
          ><b class="font-bold text-black-100">{{
            t('property.access.guestSignupBanner.descriptionBold')
          }}</b></template
        >
      </i18n-t>
    </div>
    <div class="flex shrink-0 gap-2">
      <button
        type="button"
        class="inline-flex h-10 items-center rounded-[10px] px-4 text-[13px] font-semibold text-black-100 transition-colors hover:bg-white/70"
        @click="emit('sign-in')"
      >
        {{ t('property.shell.signIn') }}
      </button>
      <button
        type="button"
        class="inline-flex h-10 flex-1 items-center justify-center rounded-[10px] bg-black-100 px-[18px] text-[13px] font-bold text-white transition-colors hover:bg-black-90 tablet:flex-none tablet:justify-start"
        @click="emit('sign-up')"
      >
        <span
          >{{ t('property.shell.signUpFreeArrow') }}
          <span
            class="inline-block rtl:-scale-x-100"
            aria-hidden="true"
            >→</span
          ></span
        >
      </button>
    </div>
  </div>
</template>
